import { RefObject, useEffect, useRef } from 'react'

/**
 * Focuses (and selects the text of) the returned input ref each time `open` turns true, so a
 * create modal's name box is ready to type into without a click.
 */
export default function useFocusWhenOpen(open: boolean): RefObject<HTMLInputElement | null> {
  const ref = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (!open) return
    ref.current?.focus()
    ref.current?.select()
  }, [open])

  return ref
}
